// import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { type InviteInfo } from '~/features/home/apis/mainInfo'
// import Button from '~/shared/components/buttons/Button'
import useViewport from '~/shared/hooks/useViewport'
import theme from '~/shared/styles/theme'

interface Props {
  inviteInfo: InviteInfo
}

function PerformanceInfo({ inviteInfo }: Props) {
  const viewport = useViewport()
  const isMobile = viewport < theme.deviceSizes.medium

  const Bg = `${import.meta.env.VITE_STATIC_ENDPOINT}/assets/background/2x-1920-bg-home-performance.webp`
  const BgMobile = `${import.meta.env.VITE_STATIC_ENDPOINT}/assets/background/2x-390-bg-home-performance.webp`

  // const navigate = useNavigate()

  return (
    <Wrapper>
      <ContentBox>
        <Title>{inviteInfo.title}</Title>
        <Desc>{inviteInfo.desc}</Desc>
        {/* <DetailButton
          $width={171}
          $height={58}
          $fontSize={24}
          $variant="transparent"
          onClick={() => navigate('/general-participation/info')}
        >
          자세히 보기
        </DetailButton> */}
      </ContentBox>
      <Background src={isMobile ? BgMobile : Bg} alt="performance-background" />
    </Wrapper>
  )
}

export default PerformanceInfo

const Wrapper = styled.div`
  position: relative;
  z-index: 1;

  display: flex;
  align-items: center;

  aspect-ratio: 1920/1080;
  width: 100%;
  max-height: 1080px;

  background-color: #f6d9e3;

  @media ${theme.device.medium} {
    align-items: start;
    height: 100vh;
  }
`

const Background = styled.img`
  position: absolute;
  z-index: ${theme.zIndex.belowDefault};
  top: 0;
  right: 0;
  left: 0;

  width: 100%;
  max-width: 1920px;
  height: 100%;
  margin: 0 auto;

  object-fit: contain;

  /* @media ${theme.device.large} {
    gap: 12px;
    align-items: flex-start;
    width: 70%;
    margin-left: 10%;
  } */

  @media ${theme.device.medium} {
    object-fit: cover;
  }
`

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(5px, ${theme.calculatePcVw(36)}, 36px);
  justify-content: center;

  margin-left: 15%;

  @media ${theme.device.medium} {
    box-sizing: border-box;
    margin-top: 56px;
    margin-left: 0;
    padding: 20px;
  }
`

const Title = styled.h1`
  width: 100%;

  font-family: NanumSquareNeo-Heavy, sans-serif;
  font-size: 48px;
  font-weight: 500;
  line-height: 140%;

  @media ${theme.device.large} {
    font-size: 42px;
  }

  @media ${theme.device.medium} {
    width: 100%;
    font-size: 36px;
  }
`

const Desc = styled.p`
  width: 100%;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 400;
  line-height: 140%;
  text-align: left;
  word-wrap: break-word;
  white-space: pre-wrap;

  @media ${theme.device.large} {
    font-size: 18px;
  }

  @media ${theme.device.medium} {
    width: 100%;

    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 21px;
    font-weight: 400;
    line-height: 29px;
    text-align: left;
  }
`

// const DetailButton = styled(Button)`
//   cursor: pointer;

//   z-index: 99;

//   width: 171px;
//   height: 58px;

//   font-family: NanumSquareNeo-Bold, sans-serif;
//   font-size: 20px;
//   color: black;

//   background-color: transparent;
//   border: 1px solid ${theme.colors.grey_5};

//   @media ${theme.device.medium} {
//     width: 100%;
//     height: 48px;
//     padding: 0;

//     font-size: 18px;
//     color: black;
//   }
// `
